const burger = (burgerSelector,menuSelector,activeBurger,activeMenu) => {
    const burger = document.querySelector(burgerSelector),
          menu = document.querySelector(menuSelector);

    burger.addEventListener('click', () => {
        if (!burger.classList.contains(activeBurger)) {
            burger.classList.add(activeBurger);
            menu.classList.add(activeMenu);
        } else {
            burger.classList.remove(activeBurger);
            menu.classList.remove(activeMenu);
        }
    });

    menu.querySelectorAll('a').forEach( link => {
        link.addEventListener('click', () => {
            burger.classList.remove(activeBurger);
            menu.classList.remove(activeMenu);
        });
    });

    window.addEventListener('click', e => {
        if (e.target.closest('.welcome__nav') === null && menu.classList.contains(activeMenu) && e.target.closest('.header__burger') === null) {
            burger.classList.remove(activeBurger);
            menu.classList.remove(activeMenu);
        }
    });
};

export default burger;